import { Time } from '@angular/common';
import { BaseDto } from './base.dto';
import { MerchantDto } from './merchant.dto';

export class BusinessHoursDto extends BaseDto {
  merchantId?: number;
  weekday?: number;
  isOpen: boolean;
  isOverNight: boolean;
  startTime?: Time;
  endTime?: Time;
  pauseStartTime?: Time;
  pauseEndTime?: Time;
  merchant: MerchantDto;
}
